import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    q: "Is my image data uploaded to any server?",
    a: "Absolutely not. ExifInvestigator processes all data using the client-side JavaScript engine. Your files stay on your machine, making it safe for sensitive legal or private investigations."
  },
  {
    q: "How does the 'Risk Score' work?",
    a: "Our heuristic engine compares over 20 metadata points, looking for anomalies like mismatched timestamps, editing software signatures, and stripped tags to determine a probability of manipulation."
  },
  {
    q: "Can this tool detect Photoshop edits?",
    a: "Yes. If an image was saved via Photoshop or Lightroom, it usually leaves specific 'Software' or 'CreatorTool' tags. We also flag if EXIF metadata was modified after the original shutter release."
  },
  {
    q: "What image formats are supported?",
    a: "We support JPEG, PNG, WebP, and TIFF. Note that some formats like PNG have limited metadata compared to standard JPEG/TIFF files."
  },
  {
    q: "Is the PDF report legally binding?",
    a: "The report is an advisory forensic tool. While it provides accurate data extraction, it should be used as part of a broader expert investigation for legal proceedings."
  },
  {
    q: "Why is the 'Original Date' sometimes missing?",
    a: "Many social media platforms (WhatsApp, Facebook, Instagram) strip metadata to protect privacy and save space. If it's missing, the image has likely been processed by a 3rd party service."
  },
  {
    q: "Does it work on mobile devices?",
    a: "Yes, our responsive interface allows you to perform forensics on-the-go directly from your smartphone's browser."
  },
  {
    q: "What is Takedown Taskforce?",
    a: "Takedown Taskforce is a leader in digital forensic services and content protection, providing tools and expertise to secure digital assets and verify authenticity."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-16 border-t border-gray-100">
      <div className="max-w-3xl mx-auto">
        <h3 className="text-2xl font-bold text-center mb-10">Frequently Asked Questions</h3>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-xl overflow-hidden bg-white">
              <button 
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition"
              >
                <span className="font-semibold text-gray-800">{faq.q}</span>
                <SafeIcon 
                  icon={openIndex === i ? FiIcons.FiChevronUp : FiIcons.FiChevronDown} 
                  className="text-gray-400" 
                />
              </button>
              <AnimatePresence>
                {openIndex === i && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-4 text-sm text-gray-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;